import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getApprovalListApi = async (params) => {
    try {
        return await get("approval_configurations", params);
    } catch (err) {
        console.error("Error fetching approval configurations:", err);
        return { data: { success: false, message: err.message } };
    }
};

export const submitApprovalApi = async (body) => {
    try {
        return await post("approval_configurations", body);
    } catch (err) {
        if (err.response?.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const updateApprovalApi = async (id, body) => {
    try {
        return await put(`approval_configurations/${id}`, body);
    } catch (err) {
        if (err.response?.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const deleteApprovalApi = async (id) => {
    try {
        return await del(`approval_configurations/delete/${id}`);
    } catch (err) {
        if (err.response?.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const getApprovalByIdApi = async (id) => {
    try {
        return await get(`approval_configurations/edit/${id}`);
    } catch (err) {
        if (err.response?.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};
